// extracted by mini-css-extract-plugin
module.exports = {"MainDiv":"_2ongP5aWTAqgug1-jbOVDY","MarginBottom":"_1X_oaEHaJQq1f5VfAKTp-A","TitleDiv":"WhgUIY7ROmC5SRUlZPgGH","RedirectIcon":"_2SDsnEYSOBfyDC45J6erxS"};